<template>
  <div class="supplier-list">

    <div v-if="supplier.suppliers.length === 0" class="suppliersEmpty">
      <br/>
      <figure class="about-img2 img-wrapper">
        <img src="../assets/static/images/illustrations/supplier.svg" />
      </figure>
      <!-- <router-link :to="'/' + 'suppliers/create/' + $i18n.locale"><p> -->
      <button class="add-btn" @click="allowToAdd">{{ $t('addSupplier') }}</button>
      <!-- </p></router-link>              -->
    </div>

    <div v-else class="suppliersEntered">
      <PulseIcon v-on:click.native="allowToAdd();" />
      
      <transition-group 
        class="supplier-cards" 
        name="slide-up" 
        tag="ul" 
        appear>

        <SupplierCard
          v-for="supplier in supplier.suppliers"
          :key="supplier.id"
          :supplier="supplier"
          class="card-columns"/>
      </transition-group>
    </div>

  </div>
</template>

<script>
import SupplierCard from '@/components/ui/SupplierCard.vue'
import PulseIcon from '@/components/common/PulseIcon.vue'
import { mapState } from 'vuex'

export default {
  components: {
    SupplierCard,
    PulseIcon
  },
  created() {
    this.$store.dispatch('supplier/fetchSuppliers')
  },
  methods: {
    allowToAdd() {
      this.$store.dispatch('client/profileCompleteness').then(response => {
        if (response && response.profile_complete === true)  {
            this.$router.push({
                path: '/suppliers/create/en'
            })
        } else {
          alert(this.$t('completeProfileFirst'))
        }
      })
    }
  },
  computed: mapState(['supplier', 'client'])
}
</script>

<style lang="scss" scoped>

.suppliersEmpty {
  // display: none; //! none when NO supplier with this client_id is found in db //
}
.suppliersEntered {
  // display: none; //! none when NO supplier with this client_id is found in db //
}

.add-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  width: 30%;
}
.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}
.supplier-list {
  margin-top: 70px;
}
.supplier-cards {
  margin-top: 20px;
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
.supplier-cards {
  width: 90%;
}
}
</style>
